import { Component, OnInit } from '@angular/core';
import { SpotlightService } from 'src/app/core/services/spotlight.service';
import { Router } from '@angular/router';
import { PassportService } from 'src/app/features/passport/services/passport.service';
import { Constants } from 'src/app/core/models/common.models';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import {AdminService} from '../../../../core/services/admin-apis/admin.service';
import { MatDialog } from '@angular/material/dialog';
import { StripeConfirmationPopupComponent } from 'src/app/features/bulk-purchase/stripe-purchase-popup/stripe-confirmation-popup/stripe-confirmation-popup.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-lineup-premiere',
  templateUrl: './lineup-premiere.component.html',
  styleUrls: ['./lineup-premiere.component.css']
})
export class LineupPremiereComponent implements OnInit {

  premierelist: any[];
  cinejoySchedule: any;
  datePipeString: string;
  isDisabled = true;
  archive = false;

  subscriptions:any[];
  tickets:any;
  agilePurchaseEnabled:boolean= environment.agilePurchaseEnabled;
  constructor(
    private adminApi: AdminService,
    private spotlightService: SpotlightService,
    private readonly passportService: PassportService,
    private authService: AuthenticationService,
      public router: Router,
    private adminService:AdminService,
    public dialog: MatDialog,
    private spinner: NgxSpinnerService,
    private agileIntegration: AgileIntegrationService,
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    if (this.router.url.includes('archive')) {
      this.archive = true;
    
      this.premierelist = [];
    
      // Call the Agiletix archive API
      this.spotlightService.getArchiveDataForSpotlight().subscribe(cmsArchiveData => {
        this.spinner.hide();
        const cmsEvents = cmsArchiveData.cinejoyArchiveSpotlights;

        cmsEvents.forEach(event => {
          event['type'] = 'new';
        });
    
          // Call the CMS archive API
          this.spotlightService.getArchiveData().subscribe(agiletixArchiveData => {
            this.spinner.hide();
            const agiletixEvents = agiletixArchiveData.cinejoyArchiveSpotlights;

            agiletixEvents.forEach(event => {
              event['type'] = 'old';
            });
    
            // Combine and prioritize CMS events over Agiletix events based on unique eventId
            this.premierelist = this.getUniqueEvents([...agiletixEvents, ...cmsEvents]);
    
            this.processPremierelist();
        
      });
    });
  }
    
    else {
      if (this.router.url.includes('lineup')) {
        this.archive = false;
      
          this.adminApi.SpotlightActiveListEvents().subscribe(data => {
            this.spinner.hide();
            this.premierelist = this.getUniqueEvents(data);
            this.processPremierelist();
          });
      }
    }

    this.authService.checkUserAuthenticated().subscribe(
      (res) => {
        if (res.userId > 0){
          this.agileIntegration.fetchTickets().subscribe(
            {
              next:(data:any)=>{
                // this.tickets=data.agiletixEvents;
                this.agileIntegration.setUserTicketList(data);
              },
              error:(error)=>{
                this.spinner.hide();
              }
            }
          )
          // this.adminService.getActiveSubscription().subscribe(
          //   {
          //     next:(data:any[])=>{
          //               this.subscriptions=data;

          //             },
          //     error:(error)=>{
          //             this.openErrorMessagePopup("Error Occured while fetching Subcription!");
          //             console.log("error while fetching subscription", error);
          //             this.spinner.hide();
          //     }
          //   }
          // );

            this.passportService.getData().then(profile => {
              localStorage.setItem(Constants.localStorageKeys.PASSPORT_PROFILE, JSON.stringify(profile));
              this.getUserDetails();
        });
      }
    });

  }

  private getUniqueEvents(events: any[]): any[] {
    const eventMap = new Map<number, any>();
  
    events.forEach(event => {
      const existingEvent = eventMap.get(event.eventId);
  
      if (!existingEvent) {
        eventMap.set(event.eventId, event);
      } else if (this.isCmsEvent(event)) {
        // If CMS event exists, prioritize it over the existing event
        eventMap.set(event.eventId, event);
      }
    });
  
    return Array.from(eventMap.values());
  }
  
  private isCmsEvent(event: any): boolean {
    return !!event.mainImage || !!event.mobilethumbimage;
  }  

  private processPremierelist() {
    this.premierelist = this.premierelist.filter(event =>
      event.cinejoySpotlightsSchedule.length > 0
    );
  
    this.spotlightService.setIsMotionGraphicsCompleted(false);
  
    // Sort the data by schedule time
    this.premierelist.sort((x: any, y: any) =>
      +new Date(x.cinejoySpotlightsSchedule[0].scheduleTimeText) -
      +new Date(y.cinejoySpotlightsSchedule[0].scheduleTimeText)
    );
    if (this.router.url.includes('archive')) {
      this.premierelist.reverse()
    }


  }

  getUserDetails() {
    this.spotlightService
      .getUserDetails()
      .toPromise()
      .then((res: any) => {
        res['userId'] = res.userID ? res.userID : res.userId;
        localStorage.setItem('userData', JSON.stringify(res));
      })
      .catch(console.error);
  }
  openErrorMessagePopup(error:any): void {
    this.dialog.open(StripeConfirmationPopupComponent, {
      // panelClass: 'pre-schedule-modalbox',
      width: '500px',
      minHeight: '15%',
      maxHeight:'50%',
      position:{
        top:'20px'
      },
      data: {
        invalidUsers:[],
        guestUsers:0,
        emptyTicketCount:0,
        ticketPrice:0 ,
        purchaseTransactionType:"subscriptionError",
        error:error
      }
    }).afterClosed().subscribe((res) => {
      console.log('===== dialog closed with response: ', res);
    })
  }
  }

  
